(function () {
  'use strict';
  var STORAGE_KEY = 'ccm_vat_pref';
  function getPreference() { try { return localStorage.getItem(STORAGE_KEY) || 'ex'; } catch (e) { return 'ex'; } }
  function setPreference(pref) { try { localStorage.setItem(STORAGE_KEY, pref); } catch (e) {} }

  function applyPreference(pref) {
    var body = document.body;
    // Update ALL toggle buttons (header + drawer)
    document.querySelectorAll('.vat-toggle-btn').forEach(function(btn) {
      btn.setAttribute('aria-checked', pref === 'inc' ? 'true' : 'false');
    });
    // Update ALL ex labels
    document.querySelectorAll('.vat-label--ex').forEach(function(el) {
      el.classList.toggle('vat-label--active', pref === 'ex');
    });
    // Update ALL inc labels
    document.querySelectorAll('.vat-label--inc').forEach(function(el) {
      el.classList.toggle('vat-label--active', pref === 'inc');
    });
    // Apply body class
    if (pref === 'inc') {
      body.classList.add('vat-show-inc');
      body.classList.remove('vat-show-ex');
    } else {
      body.classList.add('vat-show-ex');
      body.classList.remove('vat-show-inc');
    }
  }

  function init() {
    applyPreference(getPreference());
    document.dispatchEvent(new CustomEvent('ccm:vat-ready'));

    // Attach click handler to ALL toggle buttons
    document.querySelectorAll('.vat-toggle-btn').forEach(function(btn) {
      btn.addEventListener('click', function () {
        var next = getPreference() === 'ex' ? 'inc' : 'ex';
        setPreference(next);
        applyPreference(next);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();